import { render } from "./Dropdown.vue?vue&type=template&id=67f876c2&scoped=true"
import script from "./Dropdown.vue?vue&type=script&lang=ts"
export * from "./Dropdown.vue?vue&type=script&lang=ts"

import "./Dropdown.vue?vue&type=style&index=0&id=67f876c2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-67f876c2"

export default script